
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'default-avatar': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.16817 0C6.18921 0 4.58786 1.59028 4.58786 3.55556C4.58786 5.52083 6.18921 7.11111 8.16817 7.11111C10.1471 7.11111 11.7485 5.52083 11.7485 3.55556C11.7485 1.59028 10.1471 0 8.16817 0ZM8.16817 8.88889C2.7977 8.88889 1.17537 12.4444 1.17537 12.4444L0.392178 13.7778C-0.0553611 14.4896 0.203373 15.3681 1.00754 15.7222L1.37117 16H3.69278C3.69278 14.0451 5.66125 12.4444 8.16817 12.4444C10.6751 12.4444 12.6436 14.0451 12.6436 16H14.9652L15.4127 15.8333C16.1295 15.4792 16.3917 14.4896 15.9442 13.7778L15.161 12.4444C15.161 12.4444 13.5386 8.88889 8.16817 8.88889ZM5.03539 16C5.03539 14.7569 6.46892 13.7778 8.16817 13.7778C9.86742 13.7778 11.3009 14.7569 11.3009 16H5.03539Z" fill="#93A0BD"/>'
  }
})
